import React from 'react'

const Header = () => {
    return (
        <div className="header">
            <h1>Task Manager</h1>
        </div>
    )
}

export default Header